module.exports = __webpack_public_path__ + "static/media/scenario-img.d79f0298.jpg";